var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.downloadCert}},[_vm._v("下载")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas-main-con"},[_c('canvas',{staticClass:"canvas",attrs:{"width":"900px","height":"650px","id":"canvas"}}),_c('canvas',{staticClass:"canvas-mask",attrs:{"width":"900px","height":"650px","id":"canvasMask"}})])
}]

export { render, staticRenderFns }